import Image from 'next/image'

import {
  Button,
  Container,
  Divider,
  HiringStep,
  SectionHeader
} from '@/components'

import PrepaidImage from '/public/images/prepaid.webp'

import { PRE_PAID_PLANS } from '@/constants/plans'
import { PREPAID_URL } from '@/constants/links'

import { Plan, PlansHeader } from './components'

import { HIRING_STEPS } from './constants'

import styles from './Prepaid.module.scss'

export const Prepaid = () => {
  return (
    <section className={styles.plans}>
      <Container>
        <SectionHeader
          tagText="Planos Pré-Pago"
          tagBackground="white"
          title={
            <>
              A recarga Pré é <b>perfeita para consultas pontuais</b>.
              Recarregou, consultou!
            </>
          }
        />

        <div className={styles.plans__wrapper}>
          <div>
            <div className={`${styles.plans__image}`}>
              <Image
                loading="lazy"
                src={PrepaidImage}
                alt="mulher sorrindo"
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            </div>

            <ol className={styles.plans__steps}>
              {HIRING_STEPS.map(({ icon, text }, index) => (
                <HiringStep
                  icon={icon}
                  text={text}
                  index={index}
                  key={`hiringStep-${index}`}
                />
              ))}
            </ol>
          </div>

          <div>
            <PlansHeader />

            <div className={styles.plans__list}>
              {PRE_PAID_PLANS.map((plan, index) => (
                <div key={`${plan.type}-${plan.id}`}>
                  <Plan plan={plan} />

                  {index + 1 !== PRE_PAID_PLANS.length && <Divider />}
                </div>
              ))}

              <Button
                tagName="a"
                rel="noreferrer"
                variant="secondary"
                id="prepaid-redirectToLP-button"
                href={PREPAID_URL}
                className={styles.plans__redirectButton}
              >
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
